import { useEffect, useState } from "react"
import { HistoryRFICard } from "../Cards/HistoryRFICard"
import { HistorySubmittalCard } from "../Cards/HistorySubmittalCard"
import { HistoryTaskCard } from "../Cards/HistoryTaskCard"
import { SectionDivRow } from "./Components/SectionDivRow"
import { SectionDiv } from "./Components/SectionDiv"
import { RFIProps } from "@/interfaces/rfi_types"
import { TaskProps } from "@/interfaces/tasks_types"
import { SubmittalProps } from "@/interfaces/submittal_types"
import { getUserHistory } from "@/api/history"
import { InvoiceProps } from "@/interfaces/invoices_types"
import { HistoryInvoiceCard } from "./HistoryInvoiceCard"
import { HistoryNotificationProps } from "@/interfaces/history"
import { v4 as uuidv4 } from 'uuid'
import { ErrorBoundary } from "react-error-boundary"
import { HistorySectionFallback } from "../Cards/Utils/HistorySectionFallback"

export function HistorySection() {
    const [history, setHistory] = useState<HistoryNotificationProps[]>([])
    const [error, setError] = useState<string | null>(null) // Error handling if the API returns an error

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await getUserHistory()
                setHistory(data)
            } catch (error) {
                setError(error as string)
            }
        }
        fetchData()
    }, [])

    if (error) {
        return <HistorySectionFallback />
    }

    return (
        <ErrorBoundary fallback={<HistorySectionFallback />}>
            <SectionDiv className="mt-3 h-[500px]">
                <h3 className="mb-3">History:</h3>

            <SectionDivRow>
                {history.map((item) => (
                    <HistoryItemFactory item={item} key={uuidv4()} />
                    ))}
                </SectionDivRow>
            </SectionDiv>
        </ErrorBoundary>
    )
}

// We need a factory function to handle the different types of history items.
const HistoryItemFactory = ({ item }: { item: HistoryNotificationProps }) => {
    switch (item.type) {
        case "Task": {
            const taskData = item.data as TaskProps
            return <HistoryTaskCard task={taskData} key={taskData.task_id} />
        }
        case "Submittal": {
            const submittalData = item.data as SubmittalProps
            return <HistorySubmittalCard submittal={submittalData} key={submittalData.submittal_id} />
        }
        case "RFI": {
            const rfiData = item.data as RFIProps
            return <HistoryRFICard rfi={rfiData} key={rfiData.RFI_id} />
        }
        case "Invoice": {
            const invoiceData = item.data as InvoiceProps
            return <HistoryInvoiceCard invoice={invoiceData} key={invoiceData.invoice_id} />
        }
        default:
            console.log("Unknown history item type:", item.type)
            return null
    }
}

